import apiPath from '@/lib/apiPath';
import request from '@/lib/request';
import { ElMessage } from 'element-plus';
import bus from '@/lib/bus';
import { getExt, getFileType, delQuery } from '@/lib/utils';

var client: any = null;
declare let OSS: any;

export async function getClient() {
  if (!client) {
    const stsTokenRes: any = await request.get(apiPath.oss.getSTSToken);
    client = new OSS({
      region: `oss-${stsTokenRes?.Region}`,
      accessKeyId: stsTokenRes?.AccessKeyID,
      accessKeySecret: stsTokenRes?.AccessKeySecret,
      stsToken: stsTokenRes?.SecurityToken,
      bucket: stsTokenRes?.Bucket || import.meta.env.VITE_BUCKET_NAME,
      // 允许自定义域名
      endpoint: stsTokenRes?.Endpoint,
      cname: Boolean(stsTokenRes?.Endpoint),
      refreshSTSToken: async () => {
        const info = await request.get(apiPath.oss.getSTSToken);
        return {
          accessKeyId: info.AccessKeyID,
          accessKeySecret: info.AccessKeySecret,
          stsToken: info.SecurityToken,
        };
      },
      refreshSTSTokenInterval: 50 * 60 * 1000,
    });
  }
  return client;
}

export async function uploadFile(file: any, uploadAction: string, successTip = true) {
  try {
    ElMessage({
      message: '上傳中',
      type: 'info',
      grouping: true,
    });
    client = await getClient();
    //随机命名
    const fileName = `${getFileType(file.name)}/${randomName(file.name)}`;
    // 分片上传文件
    client &&
      (await client
        .multipartUpload(fileName, file)
        .then(({ res }: any) => {
          if (res.statusCode === 200) {
            bus.emit(
              'uploadSuccess',
              res.requestUrls.map((i: any) => {
                return {
                  url: delQuery(i),
                  type: getFileType(file.name),
                  action: uploadAction,
                };
              })
            );
            if (successTip) {
              ElMessage({
                message: '上傳成功',
                type: 'success',
                grouping: true,
              });
            }
            return res.requestUrls;
          } else {
            ElMessage({
              message: '上傳失敗' + JSON.stringify(res),
              type: 'error',
              grouping: true,
            });
          }
        })
        .catch((error: any) => {
          console.error(error);
          ElMessage({
            message: '上傳失敗',
            type: 'error',
            grouping: true,
          });
        }));
  } catch (error: any) {
    console.error(error);
    ElMessage({
      message: '上傳失敗',
      type: 'error',
      grouping: true,
    });
  }
}

const randomName = (name: string) => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + '.' + getExt(name);
};

export function dataURLToBlob(dataurl: any) {
  if (!dataurl) return;
  var arr = dataurl.split(',');
  var mime = arr[0] && arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
